import { Link, useNavigate } from "react-router-dom";
import { LogOut, ExternalLink } from "lucide-react";
import { Logo } from "../site/Logo";
import { TOKEN_KEY } from "../../lib/api";

export const AdminShell = ({ children, actions }) => {
  const navigate = useNavigate();
  const logout = () => {
    localStorage.removeItem(TOKEN_KEY);
    navigate("/admin");
  };
  return (
    <div className="min-h-screen bg-[#F4F3EF]">
      <header className="sticky top-0 z-40 border-b border-ink/10 bg-white/90 backdrop-blur-xl">
        <div className="mx-auto flex max-w-6xl items-center justify-between gap-3 px-4 py-3 sm:px-6">
          <Link to="/admin/dashboard" data-testid="admin-home-link"><Logo /></Link>
          <div className="flex items-center gap-2">
            {actions}
            <a href="/" target="_blank" rel="noreferrer" className="hidden rounded-full border border-ink/10 p-2.5 text-slate-700 hover:text-ink sm:block" title="Vedi sito" data-testid="admin-view-site"><ExternalLink className="h-4 w-4" /></a>
            <button onClick={logout} className="rounded-full border border-ink/10 p-2.5 text-slate-700 hover:text-ink" title="Esci" data-testid="admin-logout-button"><LogOut className="h-4 w-4" /></button>
          </div>
        </div>
      </header>
      <main className="mx-auto max-w-6xl px-4 py-8 sm:px-6 sm:py-10">{children}</main>
    </div>
  );
};
